import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { IconTrash } from 'components/icons/trash';
import { UnstyledButton } from 'components/unstyled-button';

import { useDeliveryAddressModalContext } from '../delivery-address-modal.context';
import { IDeliveryAddressLocation } from '../save-delivery-address/types';
import { ActionStatus } from '../types';

interface IDeleteDeliveryAddressButtonProps {
  addressLocation: IDeliveryAddressLocation;
}

export const DeleteDeliveryAddressButton = ({
  addressLocation,
}: IDeleteDeliveryAddressButtonProps) => {
  const { formatMessage } = useIntl();
  const { dispatchDeliveryAddressState, setDeliveryAddress } = useDeliveryAddressModalContext();

  const {
    address: { addressLine1, addressLine2, location, city, state, zip, phoneNumber },
    coordinates: { lat, lng },
  } = addressLocation;

  const handleDeleteDeliveryAddress = useCallback(() => {
    setDeliveryAddress({
      address: { addressLine1, addressLine2, location, city, state, zip, phoneNumber },
      coordinates: {
        lat,
        lng,
      },
    });
    dispatchDeliveryAddressState({ type: ActionStatus.CONFIRM_DELETE_DELIVERY_ADDRESS });
  }, [
    addressLine1,
    addressLine2,
    city,
    dispatchDeliveryAddressState,
    lat,
    lng,
    location,
    setDeliveryAddress,
    state,
    zip,
    phoneNumber,
  ]);

  return (
    <UnstyledButton
      type="button"
      onClick={handleDeleteDeliveryAddress}
      aria-label={formatMessage({ id: 'deleteAddress' })}
      data-testid="delete-delivery-address-button"
    >
      <IconTrash fill={Styles.color.primary} width="24" height="24px" />
    </UnstyledButton>
  );
};
